"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddNewCustomerModal = exports.getSearchText = exports.getError = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var monocle = require("monocle-ts");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_select_1 = require("react-select");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var customerActions = require("@caddigital/sok-reducers/lib/actions/firstLogin/customer");
var ytjActions = require("@caddigital/sok-reducers/lib/actions/firstLogin/ytj");
var FirstLoginActions = require("@caddigital/sok-reducers/lib/actions/firstLogin/form");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var Types = require("types");
var constants_1 = require("utils/constants");
require("./addNewCustomerModal.scss");
var timeout = null;
var mapStateToProps = function (state) {
    return {
        ytj: state.firstLogin.ytj,
        customer: state.firstLogin.customer,
        region: state.firstLogin.regions,
        fetchingSelectedCompany: state.firstLogin.customer.fetchingSelectedCompany === 'FETCHING'
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    toggleModal: function () { return (dispatch(customerActions.toggleNewCustomerModal()),
        dispatch(ytjActions.searchYtjClear())); },
    setCountry: function (_a) {
        var code = _a.code;
        return dispatch(customerActions.updateCustomerField('country', code));
    },
    setCompany: function (company) {
        return dispatch(customerActions.setYtjCompanyRequest(company));
    },
    selectCreatedCompany: function (id) { return function () { return (dispatch(FirstLoginActions.setCompany(id)),
        dispatch(customerActions.toggleNewCustomerModal()),
        dispatch(ytjActions.searchYtjClear())); }; },
    updateField: function (key) { return function (value) {
        return dispatch(customerActions.updateCustomerField(key, value));
    }; },
    setYtjSearchString: function (searchString) { return (dispatch(ytjActions.setSearchString(searchString)),
        searchString && dispatch(ytjActions.searchYtjRequest(searchString))); },
    createCompany: function (customer) { return function () { return (dispatch(customerActions.createCustomerRequest(customer)),
        dispatch(FirstLoginActions.updateField('street', customer.street || '')),
        dispatch(FirstLoginActions.updateField('country', customer.country || '')),
        dispatch(FirstLoginActions.updateField('postalCode', customer.postalCode || '')),
        dispatch(FirstLoginActions.updateField('city', customer.city || ''))); }; }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.withState)('tempValue', 'setTempValue', null), recompose_1.pure);
/**
 * return current value from value object
 * @param key field name
 * @param state value object
 */
var valueLens = function (key, state) {
    var val = monocle.Lens.fromPath(['values', key]).get(state);
    if (key === 'hasBusinessId') {
        return !val;
    }
    return val;
};
/**
 * Get error  by field
 * @param key
 * @param values
 */
var getError = function (key, state) {
    if (state.values.status === 'ERROR') {
        var errors = state.values.errors[key];
        if (errors) {
            return React.createElement("p", { className: 'form-error' }, errors[0]);
        }
    }
    return undefined;
};
exports.getError = getError;
/**
 * For YTJ search
 * @param isFetching
 * @return message
 */
var getSearchText = function (isFetching) {
    return isFetching
        ? (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/searchingCompany')
        : (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/noResultsFound');
};
exports.getSearchText = getSearchText;
/**
 * list of form fields
 */
var inputs = function () { return [
    {
        name: 'name',
        label: (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/company'),
        type: 'textinput'
    },
    {
        name: 'businessId',
        label: (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/businessId'),
        type: 'textinput'
    },
    {
        name: 'hasBusinessId',
        label: (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/noBusinessId'),
        type: 'checkbox'
    },
    {
        name: 'street',
        label: (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/address'),
        type: 'textinput'
    },
    {
        name: 'postalCode',
        label: (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/postalCode'),
        type: 'textinput'
    },
    {
        name: 'city',
        label: (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/city'),
        type: 'textinput'
    },
    {
        name: 'state',
        label: (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/stateProvince'),
        type: 'textinput'
    }
]; };
exports.AddNewCustomerModal = enhance(function (props) { return (React.createElement(sok_ui_1.Modal, { isOpen: props.customer.newCustomerModal, className: "first-time-add-new-modal" },
    React.createElement(sok_ui_1.Header, { onClose: props.toggleModal }, (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/addNewCompany')),
    React.createElement(sok_ui_1.Container, null,
        React.createElement(sok_ui_1.RequestStatusBox, { status: props.customer.creatingCompany, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
            (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/adding'),
            (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/companyAddedSuccessfully'),
            props.customer.createError &&
                props.customer.createError.type === 'CONFLICT'
                ? (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/companyAlreadyExist')
                : (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/errorWhileCreatingCompany')),
        React.createElement("div", { className: 'form' },
            React.createElement(sok_ui_1.Grid.Row, null,
                React.createElement(sok_ui_1.Grid.Column, null,
                    React.createElement("label", null, (0, translation_1.getLocalization)('firstTimeLogin/searchByCompanyNameOrVat')),
                    React.createElement(react_select_1.default, { classNamePrefix: "react-select", placeholder: (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/searchByCompanyName'), menuPlacement: 'auto', options: props.ytj.companies, getOptionValue: function (opt) { return opt.businessId; }, getOptionLabel: function (opt) { return opt.name; }, isClearable: false, isLoading: props.ytj.isFetching, onInputChange: function (e) {
                            var value = e;
                            props.setTempValue(value);
                            if (timeout) {
                                clearTimeout(timeout);
                            }
                            timeout = setTimeout(function () {
                                props.setYtjSearchString(value);
                                props.setTempValue(null);
                            }, constants_1.SEARCH_TIMEOUT);
                        }, onChange: props.setCompany, noOptionsMessage: function () { return (0, exports.getSearchText)(props.ytj.isFetching); } }),
                    props.fetchingSelectedCompany && (React.createElement("div", { className: 'loading-company' },
                        React.createElement(sok_ui_1.LoadingSpinner, null),
                        React.createElement("span", null, "Loading company informations"))))),
            inputs().map(function (input, key) { return (React.createElement(sok_ui_1.Grid.Row, { key: key },
                React.createElement(sok_ui_1.Grid.Column, null,
                    React.createElement("label", { htmlFor: input.name }, input.label),
                    input.type === 'textinput' ? (React.createElement(sok_ui_1.TextInput, { id: input.name, className: 'white', placeholder: input.label, value: valueLens(input.name, props.customer), onChange: function (e) {
                            return props.updateField(input.name)(e.target.value);
                        }, disabled: props.fetchingSelectedCompany })) : (React.createElement(sok_ui_1.Input, { type: 'checkbox', name: input.name, value: valueLens(input.name, props.customer), onClick: function (e) {
                            if (input.name === 'hasBusinessId') {
                                props.updateField('businessId')('');
                                props.updateField(input.name)(!e.target.checked);
                            }
                            else {
                                props.updateField(input.name)(e.target.checked);
                            }
                        } })),
                    (0, exports.getError)(input.name, props.customer)))); }),
            React.createElement(sok_ui_1.Grid.Row, null,
                React.createElement(sok_ui_1.Grid.Column, null,
                    React.createElement("label", null, (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/country')),
                    React.createElement(react_select_1.default, { menuPlacement: 'top', classNamePrefix: "react-select", className: 'select-up', placeholder: (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/country'), value: props.region.list.find(function (a) { return props.customer.values.country === a.code; }), options: props.region.list, onChange: props.setCountry, getOptionValue: function (opt) { return opt.code; }, getOptionLabel: function (opt) { return opt.name; }, isClearable: false }),
                    (0, exports.getError)('country', props.customer))))),
    React.createElement(sok_ui_1.Footer, null,
        React.createElement(sok_ui_1.Button, { color: 'base-green', disabled: props.customer.creatingCompany === 'SAVING' ||
                props.customer.creatingCompany === 'SAVED', text: props.customer.creatingCompany === 'SAVED'
                ? (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/done')
                : (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/save'), onClick: props.customer.creatingCompany === 'SAVED'
                ? props.toggleModal
                : props.createCompany(__assign({ type: 'NORMAL' }, props.customer.values)), icon: props.customer.creatingCompany === 'SAVING' ? (React.createElement(Icon_1.Icon, { className: 'fa-spinner fa-spin' })) : undefined }),
        React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('firstTimeLogin/addNewCompany/cancel'), color: 'dark-gray', onClick: props.toggleModal })))); });
